import React from 'react';
import { defaultTheme } from '../../Themes/Default';

type ProgressIconProps = {
  points: number;
  maxPoints: number;
  color?: string;
  width?: number;
  height?: number;
};

const ProgressIcon: React.FunctionComponent<ProgressIconProps> = ({
  color = defaultTheme.UI_COLORS.success,
  points,
  maxPoints,
  width = 22,
  height = 22,
}): React.ReactElement => {
  const percent = Math.round((points / maxPoints) * 100);

  let icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      width={width}
      height={height}
    >
      <path
        fill="#778888"
        d="M11,2a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-2A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z"
      />
    </svg>
  );

  if (percent > 0 && percent < 25) {
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        width={width}
        height={height}
      >
        <path
          fill={color}
          d="M11,2a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-2A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z"
        />
        <path fill={color} d="M16,6.05,11,11V4A7,7,0,0,1,16,6.05Z" />
      </svg>
    );
  }

  if (percent === 25) {
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        width={width}
        height={height}
      >
        <path fill="none" d="M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z" />
        <path
          fill={color}
          d="M11,2a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-2A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z"
        />
        <path fill={color} d="M18,11H11V4a7,7,0,0,1,7,7Z" />
      </svg>
    );
  }

  if (percent > 25 && percent < 50) {
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        width={width}
        height={height}
      >
        <path fill="none" d="M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z" />
        <path
          fill={color}
          d="M11,2a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-2A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z"
        />
        <path fill={color} d="M18,11A7,7,0,0,1,16,16L11,11V4a7,7,0,0,1,7,7Z" />
      </svg>
    );
  }

  if (percent === 50) {
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        width={width}
        height={height}
      >
        <path fill="none" d="M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z" />
        <path
          fill={color}
          d="M11,2a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-2A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z"
        />
        <path fill={color} d="M18,11a7,7,0,0,1-7,7V4a7,7,0,0,1,7,7Z" />
      </svg>
    );
  }

  if (percent > 50 && percent < 75) {
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        width={width}
        height={height}
      >
        <path fill="none" d="M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z" />
        <path
          fill={color}
          d="M11,2a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-2A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z"
        />
        <path
          fill={color}
          d="M18,11A7,7,0,0,1,6.05,16L11,11V4a7,7,0,0,1,7,7Z"
        />
      </svg>
    );
  }

  if (percent === 75) {
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        width={width}
        height={height}
      >
        <path fill="none" d="M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z" />
        <path
          fill={color}
          d="M11,2a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-2A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z"
        />
        <path fill={color} d="M18,11A7,7,0,1,1,4,11h7V4a7,7,0,0,1,7,7Z" />
      </svg>
    );
  }

  if (percent > 75 && percent < 100) {
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        width={width}
        height={height}
      >
        <path fill="none" d="M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z" />
        <path
          fill={color}
          d="M11,2a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-2A11,11,0,1,0,22,11,11,11,0,0,0,11,0Z"
        />
        <path
          fill={color}
          d="M18,11A7,7,0,1,1,6.05,6.05l5,5V4a7,7,0,0,1,7,7Z"
        />
      </svg>
    );
  }

  if (percent === 100) {
    icon = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 22"
        width={width}
        height={height}
      >
        <circle fill={color} cx="11" cy="11" r="11" />
        <g>
          <path
            className="st1"
            fill="#fff"
            d="M16.5,7.4l-7,8.1c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0-0.2,0   s-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1l-3.2-3.4c-0.3-0.3-0.3-0.8,0-1.1   c0.3-0.3,0.8-0.3,1.1,0l2.7,2.9l6.5-7.5c0.3-0.3,0.7-0.4,1-0.1C16.8,6.6,16.8,7.1,16.5,7.4z"
          />
        </g>
        <g>
          <path
            fill="#fff"
            d="M8.4,15.6C8.4,15.6,8.5,15.6,8.4,15.6C8.5,15.7,8.5,15.6,8.4,15.6C8.4,15.6,8.4,15.6,8.4,15.6z"
          />
        </g>
      </svg>
    );
  }

  return icon;
};

export default ProgressIcon;
